import axios from 'axios'
import type { ProxyAssignedUserList, ProxyAssignmentCount } from '@numeo/types'

const BASE = '/gluon/proxy-health'

export type { ProxyAssignedUserList, ProxyAssignmentCount }

export const proxyHealthApi = {
    async listAssignedUsers(page: number, limit: number): Promise<ProxyAssignedUserList> {
        const { data } = await axios.get<{ success: boolean; data: ProxyAssignedUserList }>(`${BASE}/assign/list`, { params: { page, limit } })
        return data.data
    },

    async countAssignedUsers(): Promise<ProxyAssignmentCount> {
        const { data } = await axios.get<{ success: boolean; data: ProxyAssignmentCount }>(`${BASE}/assign/count`)
        return data.data
    },
}
